module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/th_6-ac709f070e956a25eb0fd31b64cb58e6.jpg";